module.exports = __webpack_public_path__ + "img/3.5588fb3a.jpg";